module.exports = __webpack_public_path__ + "static/Iskak Hendrawan-7fe7d62d21baa3164e24929a1379a73e.jpeg";